import { invariant } from '../util/invariant';
import { safeArrayAccess } from '../util/safeArrayAccess';

/**
 * This helper class is meant to provide an iterator for the
 * composition time offsets that are represented in a compact way
 * inside a ctts mp4 box.
 */
export class CompositionTimeHelper {

  private i = 0;
  private j = 0;

  constructor(
    private sample_counts: number[],
    private sample_offsets: number[],
  ) {
    invariant(sample_counts.length === sample_offsets.length, 'sample_counts and sample_offsets should have the same length');
  }


  getNextCompositionOffset(): number {
    if (this.sample_counts.length === 0) {
      return 0;
    }

    const offset = safeArrayAccess(this.sample_offsets, this.i);

    this.j++;
    if (this.j === this.sample_counts[this.i]) {
      this.i++;
      this.j = 0;
    }
    return offset;
  }
}
